import { render, staticRenderFns } from "./BootButton.vue?vue&type=template&id=73da6a88&scoped=true&"
import script from "./BootButton.vue?vue&type=script&lang=js&"
export * from "./BootButton.vue?vue&type=script&lang=js&"
import style0 from "./BootButton.vue?vue&type=style&index=0&id=73da6a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73da6a88",
  null
  
)

export default component.exports